import React, { useRef, useEffect } from "react";
import * as d3 from "d3";

const DonutGraph = ({ data, width = 250, height = 250, colors = [] }) => {
  const svgRef = useRef();

  useEffect(() => {
    const radius = Math.min(width, height) / 2;
    const svg = d3
      .select(svgRef.current)
      .attr("width", width)
      .attr("height", height)
      .append("g")
      .attr("transform", `translate(${width / 2}, ${height / 2})`);

    // Criação dos arcos
    const pie = d3.pie().value((d) => d.value);
    const arcs = pie(data);

    const arc = d3
      .arc()
      .innerRadius(radius * 0.6)
      .outerRadius(radius);

    const color = colors.length > 0
      ? d3.scaleOrdinal(colors)
      : d3.scaleOrdinal(d3.schemeCategory10);

    // Criar a tooltip
    const tooltip = d3
      .select("body")
      .append("div")
      .style("position", "absolute")
      .style("background", "rgba(0, 0, 0, 0.7)")
      .style("color", "white")
      .style("padding", "8px 12px")
      .style("border-radius", "4px")
      .style("pointer-events", "none")
      .style("font-size", "12px")
      .style("opacity", 0);

    // Renderizar os segmentos
    svg
      .selectAll("path")
      .data(arcs)
      .join("path")
      .attr("d", arc)
      .attr("fill", (d, i) => color(i))
      .attr("stroke", "white")
      .attr("stroke-width", 2)
      .on("mouseover", (event, d) => {
        // Exibe a tooltip com as informações da categoria
        tooltip
          .style("opacity", 1)
          .html(
            `<strong>${d.data.label}</strong><br>Restaurantes: ${d.data.value.toLocaleString(
              "pt-BR"
            )}`
          )
          .style("left", event.pageX + 10 + "px")
          .style("top", event.pageY - 20 + "px");
      })
      .on("mousemove", (event) => {
        // Move a tooltip conforme o mouse se move
        tooltip
          .style("left", event.pageX + 10 + "px")
          .style("top", event.pageY - 20 + "px");
      })
      .on("mouseout", () => {
        // Esconde a tooltip ao tirar o mouse
        tooltip.style("opacity", 0);
      });

    // Adiciona o texto no centro dos segmentos
    svg
      .selectAll("text")
      .data(arcs)
      .join("text")
      .attr("transform", (d) => `translate(${arc.centroid(d)})`)
      .attr("text-anchor", "middle")
      .attr("font-size", "12px")
      .attr("fill", "black")
      .text((d) => d.data.label);
  }, [data, width, height, colors]);

  return <svg ref={svgRef}></svg>;
};

export default DonutGraph;
